
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamRandomConfig,
  StructExamQuestionConfig
} from "@/lib/model/exambuilder/exam-v2";
import draggable from "vuedraggable";
import request from "@/lib/request/request";
import {
  QuestionV2Object,
  QuestionV2,
  EnumQuestionType
} from "@/lib/model/exambuilder/question-v2";
import Auth from "@/lib/common/auth";
import {
  DimensionObject,
  QuestionDimension
} from "@/lib/model/exambuilder/dimension-v2";
import QuestionCardV2 from "@/views/ai-builder/question-card-v2/question-card-v2.vue";
import QuestionEdit from "@/views/ai-builder/components/question-edit.vue";
import Loading from "../../../components/loading.vue";
import { EOF_TOKEN } from "html2canvas/dist/types/css/syntax/tokenizer";
import MsgRequest from "@/lib/model/message/MsgRequest";
import AppendAskConfig from "@/lib/model/exambuilder/ai-ask";

@Component({
  components: { QuestionCardV2, QuestionEdit, draggable, Loading }
})
export default class SetQuestion extends Vue {
  @Prop({ type: ExamV2Custom, default: new ExamV2Custom() })
  exam!: ExamV2Custom; //考试Model
  @Prop({ type: String, default: "" }) fromTemplateStoreId!: string; //模板库带入id

  dimensionMap: Map<string, QuestionDimension> = new Map();
  questionCount = 0;
  questionList: QuestionV2[] = [];
  selectedQuestionList: QuestionV2[] = [];
  selectedDimension: QuestionDimension | null = null;
  selectAllStatus = false;

  loadDataTime = 0; // 加载数据时间戳

  //弹窗model
  currentQuestion: QuestionV2 | null = null;
  showDel = false;
  showQuestionEdit = false;
  // 数据加载完成前不展示空页面
  dataLoaded = false;
  showSearch = false;
  groupDel = false;
  //筛选
  // isAppendAsk = 0;
  filterQuestionType = 0;
  filterScoreRuleStatus = 0;
  filterOwnerStatus = 0;
  filterIndustry = -1;
  filterPost = -1;
  searchKeyword = "";
  searchType = 0;
  searchTimer = 0;
  groupDelText = "";
  groupName = "";
  groupDelType = 1;
  groupDelIndex = 0;
  delQuestionId = 0;

  searchTypeOptions = [
    {
      value: 0,
      label: "题干关键字"
    },
    {
      value: 1,
      label: "备注关键字"
    }
  ];

  questionType = [
    {
      label: "题型",
      value: 0
    },
    {
      label: "全部",
      value: 0
    },
    {
      label: "视频题",
      value: 6
    },
    {
      label: "选择题",
      value: 7
    },
    {
      label: "音频题",
      value: 8
    },
    {
      label: "填空题",
      value: 5
    }
  ];

  scoreRules = [
    {
      label: "评分",
      value: 0
    },
    {
      label: "全部",
      value: 0
    },
    {
      label: "AI打分",
      value: 10
    },
    {
      label: "自动打分",
      value: 20
    },
    {
      label: "手动打分",
      value: 30
    }
  ];

  questionBaseList = [
    {
      label: "题库",
      value: 0
    },
    {
      label: "全部",
      value: 0
    },
    {
      label: "标准题库",
      value: 10
    },
    {
      label: "私有题库",
      value: 20
    }
  ];
  // inquiryList = [
  //   {
  //     label: "追问",
  //     value: 0
  //   },
  //   {
  //     label: "全部",
  //     value: 0
  //   },
  //   {
  //     label: "未设置追问",
  //     value: 2
  //   },
  //   {
  //     label: "已设置追问",
  //     value: 1
  //   }
  // ];

  industryList: any[] = [];
  postList: any[] = [];

  //内部使用
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  get isStartFilter() {
    return (
      true &&
      // this.isAppendAsk === 0 &&
      this.filterQuestionType === 0 &&
      this.filterScoreRuleStatus === 0 &&
      this.filterOwnerStatus === 0 &&
      this.filterIndustry === -1 &&
      this.filterPost === -1 &&
      this.searchKeyword === ""
    );
  }
  //模板进入 过滤掉非模本自带的题目  需要吗？
  get questionListFilter() {
    // if (this.fromTemplateStoreId) {
    //   return this.questionList.filter((item: QuestionV2) => {
    //     return this.exam.questionIdList.includes(item.questionId);
    //   });
    // } else {
    //   return this.questionList;
    // }
    return this.questionList;
  }

  async mounted() {
    if (this.setWeb) {
      this.searchTypeOptions.push({ value: 2, label: "题目ID" });
    }
    const qo = await DimensionObject.get({
      dimensionKeyList: this.exam.dimensionKeyList,
      isExamEnv: 1, // 历史面试数据兼容需求，写死1
      withExamId: this.exam.examId // 历史面试数据兼容需求，传面试id
    });

    if (qo.list.length < this.exam.dimensionKeyList.length) {
      // 有维度被删除了，需要重新生成维度列表
      this.exam.dimensionKeyList = qo.list.map(dim => {
        return dim.dimensionKey;
      });
    }

    for (const selectedKey of this.exam.dimensionKeyList) {
      for (const dim of qo.list) {
        if (dim.dimensionKey === selectedKey) {
          this.dimensionMap.set(dim.dimensionKey, dim);
          if (!this.selectedDimension) {
            this.selectedDimension = dim;
          }
        }
      }
    }

    await this.getCompany();
    await this.initData();
    await this.getQuestionList();
    await this.getFilterList();
    document.body.addEventListener("click", this.hideInput);
  }

  beforeDestroy() {
    document.body.addEventListener("click", this.hideInput);
  }

  async getCompany() {
    const res = await MsgRequest.getCompanyInfo(parseInt(Auth.companyId));
    if (res.data.hasQuestionOwnerStatusPrivate2) {
      this.questionBaseList.push({
        value: 22,
        label: "历史公有题库保留"
      });
    }
  }

  clearFilter() {
    this.filterQuestionType = 0;
    this.filterScoreRuleStatus = 0;
    this.filterOwnerStatus = 0;
    // this.isAppendAsk = 0;
    // this.filterIndustry = -1;
    // this.filterPost = -1;
    this.searchKeyword = "";
    this.getQuestionList();
  }

  hideInput() {
    this.showSearch = false;
  }

  async getFilterList() {
    const {
      data: { data }
    } = await request.post("/aiExam/question2/features", {
      companyId: Number(Auth.companyId)
    });
    this.industryList = [
      { label: "行业", value: -1 },
      { label: "全部", value: -1 },
      ...(data as any).questionIndustryList.map((el: any) => ({
        label: el.name,
        value: el.questionIndustryId
      }))
    ];
    this.postList = [
      { label: "岗位", value: -1 },
      { label: "不限", value: -1 },
      ...(data as any).questionPositionList.map((el: any) => ({
        label: el.name,
        value: el.questionPositionId
      }))
    ];
  }

  search() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.getQuestionList();
      this.searchTimer = 0;
    }, 100);
  }

  getLabel(type: number, arr: any[]) {
    let label = "";
    try {
      arr.forEach(el => {
        if (el.value === type) {
          label = el.label;
          throw new Error("");
        }
      });
    } catch (error) {
      label;
    }
    return label;
  }
  // 追问
  // setInquiry(type: number) {
  //   this.isAppendAsk = type;
  //   this.getQuestionList();
  // }
  setFilterQuestionType(type: number) {
    if (
      this.filterScoreRuleStatus != 0 &&
      type == EnumQuestionType.EnumQuestionTypeNewSingleChoice
    ) {
      // 筛选了状态就不能选选择题了
      return;
    }

    this.filterQuestionType = type;
    if (
      this.filterQuestionType ==
      EnumQuestionType.EnumQuestionTypeNewSingleChoice
    ) {
      this.filterScoreRuleStatus = 0;
    }
    this.getQuestionList();
  }

  setScoreRuleStatus(type: number) {
    if (
      this.filterQuestionType ==
        EnumQuestionType.EnumQuestionTypeNewSingleChoice &&
      type != 0
    ) {
      // 选择题不能筛选状态
      return;
    }
    this.filterScoreRuleStatus = type;
    // if (this.filterScoreRuleStatus == EnumQuestionType.EnumQuestionTypeNewSingleChoice) {
    //   this.filterQuestionType = EnumQuestionType.EnumQuestionTypeVideo;
    // }

    this.getQuestionList();
  }

  setOwnerFilterStatus(type: number) {
    this.filterOwnerStatus = type;
    this.getQuestionList();
  }

  setFilterIndustry(type: number) {
    this.filterIndustry = type;
    this.getQuestionList();
  }

  setFilterPost(type: number) {
    this.filterPost = type;
    this.getQuestionList();
  }

  @Watch("exam")
  async initData() {
    this.filterIndustry = this.exam.industryId;
    this.filterPost = this.exam.positionId;

    if (this.exam.questionIdList && this.exam.questionIdList.length > 0) {
      const param = {
        questionIdList: this.exam.questionIdList,
        dimensionKeyFilterList: this.exam.dimensionKeyList,
        pageSize: 500,
        isExamEnv: 1, // 历史面试数据兼容需求，写死1
        withExamId: this.exam.examId // 历史面试数据兼容需求，传面试id
      };
      const qo2 = await QuestionV2Object.get(param);
      this.selectedQuestionList = qo2.list;
      if (this.selectedQuestionList.length < this.exam.questionIdList.length) {
        // 数据不一致，有题目被删除，需要重新生成题目list
        this.exam.questionIdList = this.selectedQuestionList.map(question => {
          return question.questionId;
        });
      }
      // this.selectedQuestionList.sort((q1, q2) => {
      //   return (
      //     this.exam.questionIdList.indexOf(Number(q1.questionId)) -
      //     this.exam.questionIdList.indexOf(Number(q2.questionId))
      //   );
      // });
    }
    this.checkDimHasQuestion();
  }
  page = 1;
  pageSize = 10;
  isLoadingQuestion = false;

  async getQuestionList(str?: string) {
    this.isLoadingQuestion = true;
    this.selectAllStatus = false;
    if (str === "toFirstPage") {
      this.page = 1;
    }
    const param = {
      page: this.page,
      pageSize: this.pageSize,
      dimensionKeyFilterList: this.exam.dimensionKeyList,
      isExamEnv: 1, // 历史面试数据兼容需求，写死1
      withExamId: this.exam.examId // 历史面试数据兼容需求，传面试id
    };
    if (this.selectedDimension) {
      param["dimensionKey"] = this.selectedDimension.dimensionKey;
    }
    // 追问
    // if (this.isAppendAsk != 0) param["isAppendAsk"] = this.isAppendAsk;

    if (this.filterQuestionType != 0)
      param["questionType"] = this.filterQuestionType;

    if (this.filterScoreRuleStatus != 0)
      param["scoreRuleStatus"] = this.filterScoreRuleStatus;
    if (this.filterOwnerStatus != 0)
      param["ownerStatus"] = this.filterOwnerStatus;

    if (this.searchKeyword != "") {
      if (this.searchType == 0) param["descLike"] = this.searchKeyword;
      else if (this.searchType == 1) param["remarkLike"] = this.searchKeyword;
      else if (this.searchType == 2) param["questionId"] = this.searchKeyword;
    }

    if (this.filterIndustry != -1) {
      param["questionIndustryIdList"] = [this.filterIndustry];
    }
    if (this.filterPost != -1) {
      param["questionPositionIdList"] = [this.filterPost];
    }
    try {
      const qo2 = await QuestionV2Object.get(param);
      const list = qo2.list;
      for (const q of list) {
        for (const sq of this.selectedQuestionList) {
          if (sq.questionId === q.questionId) {
            sq.assign(q);
            q.selected = true;
          }
        }
      }
      this.questionList = list;
      this.questionCount = qo2.count;
      this.dataLoaded = true;
      this.selectAllStatus = this.questionList.every(el => el.selected);
    } catch (e) {
      // errCount++;
    }

    if (this.$refs.questionContent) {
      (this.$refs.questionContent as HTMLElement).scrollTop = 0;
    }
    this.isLoadingQuestion = false;
  }

  dontDel() {
    this.groupDel = false;
  }

  deleteQuestionGroup() {
    if (this.groupDelType === 1) {
      this.exam.examRandomConfigList.splice(this.groupDelIndex, 1);
    } else if (this.groupDelType === 2) {
      this.exam.examRandomConfigList.forEach((el, index) => {
        if (index === this.groupDelIndex) {
          el.questionIdList = el.questionIdList.filter(
            el => el !== this.delQuestionId
          );
          el.questionList = el.questionList.filter(
            el => el.questionId !== this.delQuestionId
          );
          el.questionNumber = el.questionNumber - 1;
        }
      });
    } else {
      this.exam.examRandomConfigList.forEach((el, index) => {
        if (index === this.groupDelIndex) {
          el.questionIdList = el.questionIdList.filter(
            el => el !== this.delQuestionId
          );
          el.questionList = el.questionList.filter(
            el => el.questionId !== this.delQuestionId
          );
        }
      });
    }
    this.deleteQuestion(this.delQuestionId);
    this.checkDimHasQuestion();
    this.onDataChange();
    this.groupDel = false;
  }

  deleteQuestion(questionId: number) {
    for (const i in this.selectedQuestionList) {
      if (this.selectedQuestionList[i].questionId == questionId) {
        this.selectedQuestionList.splice(Number(i), 1);
        break;
      }
    }
    //同时去掉题目对应配置list 和 分数list
    for (let i = 0; i < this.exam.examQuestionConfigList.length; i++) {
      if (this.exam.examQuestionConfigList[i].questionId == questionId) {
        this.exam.examQuestionConfigList.splice(Number(i), 1);
        i--;
      }
    }
    for (let i = 0; i < this.exam.examScoreConfigList.length; i++) {
      if (this.exam.examScoreConfigList[i].questionId == questionId) {
        this.exam.examScoreConfigList.splice(Number(i), 1);
        i--;
      }
    }
  }
  // 选中当前页所有题目
  selectQuestionCurrentPage(val: boolean) {
    const pass: any = true;
    for (const item of this.questionList) {
      if (
        (this.selectAllStatus && !item.selected) ||
        (!this.selectAllStatus && item.selected)
      ) {
        // const res = this.selectQuestion(item.questionId);
        this.selectQuestion(item.questionId);
        // if (!res) {
        //   pass = res;
        // }
      }
    }
    // if (!pass) {
    //   this.selectAllStatus = false;
    // }
  }
  clearing = false;
  // 清空所有题目
  clearAllQuestion() {
    if (this.clearing) return;
    this.clearing = true;
    for (const item of this.selectedQuestionList) {
      Promise.resolve().then(() => {
        this.selectQuestion(item.questionId);
      });
    }
    setTimeout(() => {
      this.selectAllStatus = false;
      this.clearing = false;
    }, 0);
  }

  selectQuestion(questionId: any): boolean | undefined {
    let hasSelected = false;
    for (const q of this.selectedQuestionList) {
      if (q.questionId == questionId) {
        hasSelected = true;
        break;
      }
    }

    let question = null;
    for (const q of this.questionList) {
      if (q.questionId == questionId) {
        question = q;
        break;
      }
    }
    if (!hasSelected) {
      if (question) {
        //检查上限  最多100道题，其中视频题最多50道
        if (question.questionType === 6) {
          // 视频题
          const videoCount = this.selectedQuestionList.filter(el => {
            return el.questionType === 6;
          }).length;
          if (videoCount >= 50) {
            question.selected = false;
            this.$message.warning("单场面试最多可选50道视频题");
            return;
          }
        }

        if (
          this.selectedQuestionList.length <= 100 ||
          (this.exam.isRandomQuestions == 1 &&
            this.selectedQuestionList.length <= 500)
        ) {
          question.selected = true;
          this.selectedQuestionList.push(question);
        } else {
          if (this.exam.isRandomQuestions == 1)
            this.$message.warning("随机抽题时单场面试最多可选500题");
          else this.$message.warning("单场面试最多可选100题");
          question.selected = false;
          return;
        }
      }
    } else {
      if (question) question.selected = false;
      if (this.exam.isRandomQuestions === 1) {
        // 抽题组卷
        const effectGroup = this.exam.examRandomConfigList.filter(el =>
          el.questionIdList.includes(questionId)
        );
        const index = this.exam.examRandomConfigList.findIndex(el =>
          el.questionIdList.includes(questionId)
        );
        this.groupDelIndex = index;
        this.delQuestionId = questionId;
        if (effectGroup.length > 0) {
          const item = effectGroup[0];
          console.log(item);
          if (item.questionList.length === 1) {
            // 最后一道题
            this.groupDelType = 1;
            this.groupDelText =
              "由于该题目是以下分组的最后一道题，删除后系统将同时删除该题目分组的全部设置：";
          } else if (item.questionList.length === item.questionNumber) {
            // 影响抽题数量
            this.groupDelType = 2;
            this.groupDelText =
              "删除该题目后，系统将变更以下题目分组的抽题数量，如有不妥请及时调整：";
          } else {
            this.groupDelType = 3;
            this.groupDelText =
              "删除该题目后，系统将同时在以下题目分组中删除该题目：";
          }
          this.groupName = `组${index + 1}：${item.name || "抽题组卷题"} ｜ ${
            item.questionList.length
          }抽${item.questionNumber} ｜ ${item.getQuestionTypeText()}`;
          this.groupDel = true;
          return;
        }
      }
      this.deleteQuestion(questionId);
    }
    console.log(this.exam.examQuestionConfigList);
    console.log(this.exam.examScoreConfigList);

    this.checkDimHasQuestion();
    this.onDataChange();
  }
  onMove(res: any) {
    this.$nextTick(() => {
      this.onDataChange();
    });
    return true;
  }

  // 检查维度下是否有选择题目
  checkDimHasQuestion() {
    this.dimensionMap.forEach((dim, key) => {
      dim.selectedQuestionCount = 0;
    });

    for (const qu of this.selectedQuestionList) {
      for (const dimKey of qu.dimensionKeyList) {
        const dim = this.dimensionMap.get(dimKey);
        if (dim) dim.selectedQuestionCount++;
      }
    }
  }

  selectDimenson(dim: QuestionDimension) {
    console.log(dim);
    if (this.selectedDimension != dim) {
      this.selectedDimension = dim;
    }

    this.page = 1;
    this.getQuestionList();
  }

  onDataChange() {
    this.exam.questionIdList = [];
    const originExamQuestionConfigList = JSON.parse(
      JSON.stringify(this.exam.examQuestionConfigList)
    );
    this.exam.examQuestionConfigList = [];
    for (const item of this.selectedQuestionList) {
      this.exam.questionIdList.push(item.questionId);
      // 添加额外题目配置项 , 追问相关配置赋值
      const {
        needAskAppend,
        appendAskConfig,
        appendMaxAskNumber,
        appendScorePercent
      } = this.handleAppendAskInfo(
        originExamQuestionConfigList,
        item.questionId
      );
      const question = new StructExamQuestionConfig().assign({
        needAskAppend,
        appendAskConfig,
        appendMaxAskNumber,
        appendScorePercent
      });
      question.questionId = item.questionId;
      this.exam.examQuestionConfigList.push(question);
    }
    //已选题目全量data
    // this.exam.questionSelectedList = [];
    // this.exam.questionSelectedList = this.selectedQuestionList;
    this.change();
  }

  // 编辑面试，在有追问的场景下，如果调整了问题顺序、删除问题等操作，会导致追问信息缺失。
  // 因此需要将追问相关信息获取并赋值
  handleAppendAskInfo(
    originConfigList: StructExamQuestionConfig[],
    selectedQuestionId: number
  ) {
    const item = originConfigList.find(
      v => v.questionId === selectedQuestionId
    );
    const result = {
      needAskAppend: 0,
      appendScorePercent: 1,
      appendMaxAskNumber: 1,
      appendAskConfig: new AppendAskConfig()
    };
    if (item) {
      result.needAskAppend = item.needAskAppend;
      result.appendScorePercent = item.appendScorePercent;
      result.appendMaxAskNumber = item.appendMaxAskNumber;
      result.appendAskConfig = item.appendAskConfig;
    }
    return result;
  }

  onMenuItemClick(event: any) {
    switch (event.eventId) {
      case 0:
        this.onEditQuestion(event.questionId);
        break;
      case 1:
        this.onDeleteQuestion(event.questionId);
        break;
    }
  }

  getDimensionClass(dim: QuestionDimension) {
    if (dim.showError()) {
      return "dimension-item-err";
    } else
      return this.selectedDimension &&
        this.selectedDimension.dimensionKey === dim.dimensionKey
        ? "dimension-item-highlight"
        : "";
  }

  onEditQuestion(question: any) {
    this.currentQuestion = question;
    this.showQuestionEdit = true;
  }

  onDeleteQuestion(question: any) {
    this.currentQuestion = question;
    this.showDel = true;
  }

  createQuestion() {
    this.currentQuestion = null;
    this.showQuestionEdit = true;
  }

  onCloseEditQuestion(hasChanged: boolean) {
    this.currentQuestion = null;
    this.showQuestionEdit = false;
    if (hasChanged) {
      this.getQuestionList();
    }
  }

  async confirmDelete() {
    this.showDel = false;
    try {
      if (this.currentQuestion) {
        const questionId = this.currentQuestion.questionId;
        await QuestionV2Object.delete(questionId);
        this.$message.success("删除成功");
        this.getQuestionList();
      }
    } catch (e) {
      this.$message.error("删除失败，请重试");
    }
  }

  //离开前数据校验
  checkData() {
    // 不要用map.forEach迭代，因为这里需要同步拿到结果
    const iterator = this.dimensionMap.values();
    let r: IteratorResult<QuestionDimension>;
    while (((r = iterator.next()), !r.done)) {
      const dim = r.value;
      if (dim.selectedQuestionCount == 0) {
        dim.err = true;
        this.selectDimenson(dim);
        this.$forceUpdate();
        this.$message.error("请为所有维度选择题目");
        return false;
      }
    }
    return true;
  }

  @Emit()
  change() {
    return;
  }
}
